<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline" labelAlign="right">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="订单编号">
                <a-input v-model="queryParam.orderNo" placeholder="请输入" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="支付单号">
                <a-input v-model="queryParam.orderNo" placeholder="请输入" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24" v-if="advanced">
              <a-form-item label="退款单号">
                <a-input v-model="queryParam.payOrderNo" placeholder="请输入" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24" v-if="advanced">
              <a-form-item label="支付渠道">
                <a-select placeholder="请选择" v-model="queryParam.payMethod" style="width: 100%" allow-clear>
                  <a-select-option :key="item.id" v-for="item in payMethod"> {{ item.name }} </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24" v-if="advanced">
              <a-form-item label="支付状态">
                <a-select placeholder="请选择" v-model="queryParam.payStatus" style="width: 100%" allow-clear>
                  <a-select-option :key="item.id" v-for="item in payStatus"> {{ item.name }} </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24" v-if="advanced">
              <a-form-item label="退款状态">
                <a-select placeholder="请选择" v-model="queryParam.refundStatus" style="width: 100%" allow-clear>
                  <a-select-option :key="item.id" v-for="item in refundStatus"> {{ item.name }} </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24" v-if="advanced">
              <a-form-item label="支付类型">
                <a-select placeholder="请选择" v-model="queryParam.payType" style="width: 100%" allow-clear>
                  <a-select-option :key="item.id" v-for="item in payType"> {{ item.name }} </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24" v-if="advanced">
              <a-form-item label="状态">
                <a-select placeholder="请选择" v-model="queryParam.status" style="width: 100%" allow-clear>
                  <a-select-option :key="item.id" v-for="item in status"> {{ item.name }} </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="(!advanced && 6) || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}"
              >
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'" />
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <DetailDrawer ref="detailDrawer" />
      <CreateForm ref="CreateForm" @ok="getList"></CreateForm>
      <!-- :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        class="center-table"
      >
        <span slot="orderNo" slot-scope="text, record">
          <a-tooltip placement="topLeft" :title="record.orderNo">
            <span class="text-ellipsis">{{ record.orderNo || '--' }}</span>
          </a-tooltip>
        </span>
        <span slot="payOrderNo" slot-scope="text, record">
          <a-tooltip placement="topLeft" :title="record.payOrderNo">
            <span class="text-ellipsis">{{ record.payOrderNo || '--' }}</span>
          </a-tooltip>
        </span>
        <span slot="payMethod" slot-scope="text, record">
          <a-tooltip placement="topLeft" :title="record.payMethod | formStatus(payMethod)">
            <span class="text-ellipsis">{{ record.payMethod | formStatus(payMethod) }}</span>
          </a-tooltip>
        </span>
        <span slot="payStatus" slot-scope="text, record">
          <a-tooltip placement="topLeft" :title="record.payStatus | formStatus(payStatus)">
            <span class="text-ellipsis">{{ record.payStatus | formStatus(payStatus) }}</span>
          </a-tooltip>
        </span>
        <span slot="payType" slot-scope="text, record">
          <a-tooltip placement="topLeft" :title="record.payType | formStatus(payType)">
            <span class="text-ellipsis">{{ record.payType | formStatus(payType) }}</span>
          </a-tooltip>
        </span>
        <span slot="refundStatus" slot-scope="text, record">
          <a-tooltip placement="topLeft" :title="record.refundStatus | formStatus(refundStatus)">
            <span class="text-ellipsis">{{ record.refundStatus | formStatus(refundStatus) }}</span>
          </a-tooltip>
        </span>
        <span slot="status" slot-scope="text, record">
          <a-tooltip placement="topLeft" :title="record.status | formStatus(status)">
            <span class="text-ellipsis">{{ record.status | formStatus(status) }}</span>
          </a-tooltip>
        </span>
        <span slot="price" slot-scope="text, record">
          <a-tooltip placement="topLeft" :title="record.price">
            <span class="text-ellipsis">{{ record.price || '--' }}</span>
          </a-tooltip>
        </span>
        <span slot="actualPayAmount" slot-scope="text, record">
          <a-tooltip placement="topLeft" :title="record.actualPayAmount">
            <span class="text-ellipsis">{{ record.actualPayAmount || '0' }}</span>
          </a-tooltip>
        </span>
        <span slot="useCoupon" slot-scope="text, record">
          <span>{{ record.useCoupon == 1 ? '是' : '否' }}</span>
        </span>
        <span slot="couponDiscount" slot-scope="text, record">
          <a-tooltip placement="topLeft" :title="record.couponDiscount">
            <span class="text-ellipsis">{{ record.couponDiscount || '--' }}</span>
          </a-tooltip>
        </span>
        <span slot="couponCode" slot-scope="text, record">
          <a-tooltip placement="topLeft" :title="record.couponCode">
            <span class="text-ellipsis">{{ record.couponCode || '--' }}</span>
          </a-tooltip>
        </span>
        <span slot="createTime" slot-scope="text, record">
          <a-tooltip placement="topLeft" :title="record.createTime">
            <span class="text-ellipsis">{{ record.createTime || '--' }}</span>
          </a-tooltip>
        </span>
        <span slot="action" slot-scope="text, record">
          <div class="action-right">
            <a @click="detailInfo(record, undefined)" v-hasPermi="['e64773be888d763ececa5ee41e4e1c10q:0:q']"> 详情 </a>
          </div>
        </span>
      </a-table>
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="(total) => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>
<script>
import { fetchList, delObj } from '@/api/VR/renewal'
import CreateForm from './modules/CreateForm.vue'
import { listTenant } from '@/api/system/tenant'
import { tableMixin } from '@/store/table-mixin'
import parameter from '@/mixins/parameter'
import moment from 'moment'
import { mapGetters } from 'vuex'
import DetailDrawer from './modules/DetailDrawer.vue'
export default {
  name: 'Work',
  components: {
    CreateForm,
    DetailDrawer,
  },
  mixins: [tableMixin, parameter],
  computed: {
    userType() {
      return this.$store.state.user.userTentant.type
    },
    ...mapGetters(['userTentant', 'infoUser']),
  },
  data() {
    return {
      list: [],
      queryParam: {
        pageNum: 1,
        pageSize: 10,
      },
      total: 0,
      value: [],
      ids: [],
      advanced: false,
      loading: false,
      selectedRowKeys: [],
      columns: [
        {
          title: '订单编号',
          dataIndex: 'orderNo',
          width: '120px',
          key: 'orderNo',
          align: 'center',
          scopedSlots: { customRender: 'orderNo' },
        },
        {
          title: '支付单号',
          dataIndex: 'payOrderNo',
          width: '120px',
          key: 'payOrderNo',
          align: 'center',
          scopedSlots: { customRender: 'payOrderNo' },
        },
        {
          title: '状态',
          width: '90px',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          key: 'status',
          align: 'center',
        },
        {
          title: '支付金额',
          dataIndex: 'price',
          width: '90px',
          align: 'center',
          scopedSlots: { customRender: 'price' },
        },
        {
          title: '实际支付',
          dataIndex: 'actualPayAmount',
          width: '90px',
          key: 'actualPayAmount',
          align: 'center',
          scopedSlots: { customRender: 'actualPayAmount' },
        },
        {
          title: '优惠券',
          dataIndex: 'useCoupon',
          width: '90px',
          scopedSlots: { customRender: 'useCoupon' },
          align: 'center',
        },
        {
          title: '抵扣金额',
          dataIndex: 'couponDiscount',
          width: '120px',
          key: 'couponDiscount',
          align: 'center',
          scopedSlots: { customRender: 'couponDiscount' },
        },
        {
          title: '优惠券编码',
          dataIndex: 'couponCode',
          width: '120px',
          key: 'couponCode',
          align: 'center',
          scopedSlots: { customRender: 'couponCode' },
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          width: '100px',
          align: 'center',
          scopedSlots: { customRender: 'createTime' },
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '120px',
          scopedSlots: { customRender: 'action' },
          align: 'center',
        },
      ],
    }
  },
  methods: {
    getList() {
      this.loading = true
      fetchList(this.queryParam).then((res) => {
        this.list = res.data.records
        this.total = res.data.total
        this.loading = false
      })
    },
    handleDeletes(row) {
      var that = this
      const text = row.status == 0 ? '是否确认启用此数据' : '是否确认禁用此数据'
      this.$confirm({
        title: text,
        onOk() {
          return editStatus({ id: row.id }).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('删除成功', 3)
          })
        },
        onCancel() {},
      })
    },
    detailInfo(record) {
      this.$refs.detailDrawer.show(record)
    },
    handleDelete(row) {
      var that = this
      let ids = []
      if (row.id) {
        ids = [row.id]
      } else {
        ids = this.ids
      }
      this.$confirm({
        title: '是否确认删除此数据?',
        onOk() {
          return delObj(ids).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('删除成功', 3)
          })
        },
        onCancel() {},
      })
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    resetQuery() {
      this.queryParam = {
        pageNum: 1,
        pageSize: 10,
        postCode: undefined,
        postName: undefined,
        status: undefined,
      }
      this.value = []
      this.handleQuery()
    },
    handleExport() {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk() {
          that.download(
            'vr/storage/package/export',
            {
              ...that.queryParam,
            },
            `post_${new Date().getTime()}.xlsx`
          )
        },
        onCancel() {},
      })
    },
    onChangeTime(e) {
      this.queryParam.createBeginTime = moment(e[0]).startOf('day').format('YYYY-MM-DD') + ' 00:00:00'
      this.queryParam.createEndTime = moment(e[1]).endOf('day').format('YYYY-MM-DD') + ' 23:59:59'
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
  },
  created() {
    if (this.userType == 1) {
      this.columns.splice(1, 1)
    }
    if (this.userType == 2) {
      this.columns.splice(2, 1)
    }
    this.getList()
  },
  mounted() {},
}
</script>
<style lang="less" scoped>
.table-operations {
  margin-bottom: 16px;
}

.table-operations .ant-btn {
  margin-right: 8px;
}

.ant-table-pagination {
  margin-top: 16px;
  text-align: right;
}

.table-page-search-wrapper {
  margin-bottom: 16px;
}

.table-page-search-wrapper .ant-form-item {
  margin-bottom: 16px;
}

.center-table .ant-table-thead > tr > th {
  text-align: center;
  white-space: nowrap;
}

.center-table .ant-table-tbody > tr > td {
  text-align: center;
  white-space: nowrap;
}

.center-table .ant-table-thead > tr > th,
.center-table .ant-table-tbody > tr > td {
  vertical-align: middle;
}

.center-table .ant-dropdown-link {
  display: inline-block;
}

.ant-table-pagination {
  text-align: center;
}

.center-table {
  width: 100%;
}

.center-table .ant-table-container {
  width: 100%;
}

.center-table .ant-table-content {
  text-align: center;
}

.text-ellipsis {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
}

</style>
